import React from 'react';
import { useFormContext } from 'react-hook-form';
import { TravelAuthorization_travelAuthorization } from 'travelAuthorization/TravelPlan/view/__generated__/TravelAuthorization';
import { TravelAuthorizationValues } from 'travelAuthorization/TravelPlan/view/interface';
import { AttachFormModal } from './AttachFormModal';

 interface AttachFormProps {
  travelAuthorizationData: TravelAuthorization_travelAuthorization;
}

export const AttachForm: React.FC<AttachFormProps> = ({
  travelAuthorizationData,
}) => {
  const {
    formState: { isDirty },
  } = useFormContext<TravelAuthorizationValues>();
  return (
    <AttachFormModal
      travelAuthorizationData={travelAuthorizationData}
      isDirty={isDirty}
    />
  );
};
